import { useTypedSelector } from "app/store/useTypedSelector";

import TemplateBase from "features/template/TemplateBase/TemplateBase";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import Icon from "shared/ui/atoms/Icon";

import Button from "shared/ui/controls/Button/Button";

import Search from "shared/ui/inputs/Search/Search";
import Block from "shared/ui/layout/Block/Block";
import Table from "shared/ui/layout/Table";

import { getAdminUsers, getUsersStats } from "./model/thunks";
import { IUser } from "./model/types";
import dayjs from "dayjs";

import styles from "./Profiles.module.scss";

import CreateProfileModal from "./widgets/CreateProfileModal/CreateProfileModal";
import ProfileSpvSlide from "./widgets/ProfileSpvSlide/ProfileSpvSlide";
import { dateFormats } from "shared/constants/dateConstants";

const Users = () => {
  const dispatch = useDispatch();
  const [isCreatingModal, setIsCreatingModal] = useState(false);
  const [search, setSearch] = useState("");

  const { invalidateKey, users, usersStats } = useTypedSelector(
    (state) => state.profiles
  );

  useEffect(() => {
    dispatch(getAdminUsers());
    dispatch(getUsersStats());
  }, [invalidateKey]);

  const [openedSpvId, setOpenedSpvId] = useState(0);

  const searchedProfiles = useMemo(() => {
    return (
      users?.filter(
        (el) =>
          el.first_name.toLowerCase().includes(search.toLowerCase()) ||
          el.last_name?.toLowerCase().includes(search.toLowerCase())
      ) ?? []
    );
  }, [users, search]);

  return (
    <TemplateBase
      title="Users"
      /*  additionalHeader={
        <Button onClick={() => setIsCreatingModal(true)}>
          <Icon name="Plus" />
          Create profile
        </Button>
      } */
    >
      <div className={styles.counts}>
        <Block>
          <div className={styles.count}>
            <div className={styles.countIcon}>
              <Icon name="MultiProfiles" />
            </div>
            <div>
              <div className={styles.countTitle}>Total User Profiles</div>
              <div className={styles.countSibtitle}>
                {usersStats?.total_users}
              </div>
            </div>
          </div>
        </Block>
        <Block>
          <div className={styles.count}>
            <div className={styles.countIcon}>
              <Icon name="ProfilePlus" />
            </div>
            <div>
              <div className={styles.countTitle}>
                Investors Added Last Month
              </div>
              <div className={styles.countSibtitle}>
                {usersStats?.total_recent}
              </div>
            </div>
          </div>
        </Block>
        <Block>
          <div className={styles.count}>
            <div className={styles.countIcon}>
              <Icon name="MultiProfiles" />
            </div>
            <div>
              <div className={styles.countTitle}>Overall Investment</div>
              <div className={styles.countSibtitle}>
                ${usersStats?.total_investment}
              </div>
            </div>
          </div>
        </Block>
      </div>
      <div className={styles.searchBar}>
        <Search
          placeholder="Search by profile"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Button className={styles.add}>
          <Icon name="Plus" />
          Add user
        </Button>
      </div>

      <Table<IUser>
        data={searchedProfiles}
        columns={[
          {
            title: "Name",
            dataIndex: "first_name",
            render: (_, record) => record!.first_name + " " + record!.last_name,
          },
          {
            title: "Email",
            dataIndex: "email",
            render: (_, record) => record!.email ?? "None",
          },
          {
            title: "Creation Date",
            dataIndex: "created_at",
            render: (date) => dayjs(date).format(dateFormats.dayWithHours),
          },
        ]}
      />

      <CreateProfileModal
        isOpen={isCreatingModal}
        onClose={() => setIsCreatingModal(false)}
      />
      <ProfileSpvSlide
        isOpen={!!openedSpvId}
        onClose={() => setOpenedSpvId(0)}
        spvId={openedSpvId}
      />
    </TemplateBase>
  );
};

export default Users;
